// extracted by mini-css-extract-plugin
export default {"scrolling-viewport":"PriceLists_scrolling-viewport__ZREsd","card":"PriceLists_card__Y2Mrn","header":"PriceLists_header__LCO0a","body":"PriceLists_body__MsWS2"};